import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TableLayout } from '../../Menu/Stock/containers/Layout';
import { isEmpty } from "lodash"
import { Button } from '@material-ui/core';
import PopUp from '../../../commonModules/interface/PopUp';
import { InputSelectNative } from '../../../commonModules/interface/form-input-inline';

class AgentUpdateForms extends Component {
    state = { 
        
		//Info on the electrical equipment
		agentR: "DefaultInstallerSchemaID",
		agentQ: [
			{
				id: "DefaultInstallerSchemaID",
				name: "DefaultInstallerSchemaID"
			}
		],
    }
    componentDidMount = async () =>{
        //Get Actual Schema List
        console.log('[DEBUG], paygoGet All, load schema ');
        let listSchema = [];
        try {
            const response = await fetch('/schema/list', {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': document.getElementsByName("_csrf")[0].content
				},
				credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");            
            console.log(resp);
            if (resp.content.lenght ==0) {
				console.log("[ERROR], getting schema getAll response ", resp)
				return;
            }
            //Parse content
            resp.content.map( item => {
                console.log(item);
                listSchema = listSchema.concat({id: item.id,name: item.name});
            });
            this.setState({
                agentQ:  this.state.agentQ.concat(listSchema),
            });
          } catch (err) {
            console.log("[ERROR], getting schema getAll data", err)
          }
          console.log("GET USERSCHEMA")
          console.log(this.props)
          try {
            const response = await fetch('/schema/get/userschema?id='+this.props.userID+'&type=tech', {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': document.getElementsByName("_csrf")[0].content
				},
				credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");            
            console.log(resp);
            if (resp.content.lenght ==0) {
				console.log("[ERROR], getting schema getAll response ", resp)
				return;
            }

            this.setState({
                agentR:  resp.content.user,
            });
		} catch (err) {
			console.log("[ERROR], getting schema getAll data", err)
		}

    }
    handleSubmit = async () => {
        //Change FORMS
        console.log("Changement Questionnaire")
        try {
            const response = await fetch('/schema/update/userschema', {
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': document.getElementsByName("_csrf")[0].content
				},
				body:JSON.stringify({
					type: "tech",
					userID: this.props.userID,
					user:  this.state.agentR,
				}),
				credentials: 'same-origin'
			});
            const resp = await response.json();
            console.log("[INFO], Response for list of all schema : , ");            
            console.log(resp);
            if (resp.content === "OK") {
                this.props.cancel()
              return;
            }
            console.log("[ERROR], getting schema getAll response ", resp)

		} catch (err) {
			console.log("[ERROR], getting schema getAll data", err)
		}
    }

    render() {
        console.log("[INFO] ===>> Print Questionnaire !! ")
        return (
            <PopUp
				close={this.props.cancel}
				title="Changer questionnaire"
				maxWidth="sm"
				submitAction={this.handleSubmit}
            >
				<InputSelectNative
					value={this.state.agentR}
					onChange={e => this.setState({agentR: e.target.value})}
					label="Questionnaire Enregistrement technicien"
					labelWidth={200}
					options={this.state.agentQ.map( item => (
						<option key={item.id} value={item.id}>{item.name}</option>
					))}
				/>
            </PopUp>
            //  <div>
            //     <div className="col-sm-12">
            //       <p className="c-black f-500 m-b-20">Questionnaire Enregistrement technicien</p>
            //       <div className="form-group fg-float">
            //         <div className="fg-line">
            //           <select
            //             className="form-control"
            //             value={this.state.agentR}
            //             onChange={e => this.setState({agentR: e.target.value})}>
            //             {this.state.agentQ.map( item => (
            //                 <option key={item.id} value={item.id}>{item.name}
            //                 </option>
            //               ))}
            //           </select>
            //         </div>
            //       </div>
            //     </div> 

            //     <Button 
            //         variant="contained"
            //         color="secondary"
            //         onClick={ this.handleSubmit }
            //     >Valider</Button>
            //     <br/>
            //     <Button 
            //       type="button"
            //       onClick={()=> this.props.cancel()}> 
            //         Annuler
            //     </Button> 
			// </div>
		);
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        CLIENTS: state.clients
    }
}

// function mapDispatchToProps(dispatch){
//     return bindActionCreators({
//         fetchAgents,
//         updateAgent,
//     }, dispatch)
// }
export default connect( mapStateToProps )(AgentUpdateForms);